Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityMetricsContainerView extends Backbone.View
  className: 'operator-availability-metrics-container'

  initialize: ({metrics}) ->
    ticketBox = new Customer.Views.Reports.OperatorAvailabilityMetricsCategoryBoxView
      iconClassName: 'fa fa-tags'
      metrics: [
        metrics.currentlyAttended,
        metrics.unattended,
        metrics.withoutFirstResponse,
        metrics.pending,
        metrics.scheduled
      ]
    botBox = new Customer.Views.Reports.OperatorAvailabilityMetricsCategoryBoxView
      iconClassName: 'robot-icon'
      metrics: [metrics.inAttentionByBot]
    operatorBox = new Customer.Views.Reports.OperatorAvailabilityMetricsCategoryBoxView
      iconClassName: 'fa fa-user'
      metrics: [
        metrics.logged,
        metrics.inAttention,
        metrics.available,
        metrics.paused,
        metrics.offline,
        metrics.outisdeCustomer
      ]
    @metricBoxes = [ticketBox, botBox, operatorBox]

  render: ->
    @$el.empty()
    @metricBoxes.forEach((metricBox) => @$el.append(metricBox.render().el))
    @

  displayPlaceholderContent: =>
    @$el.addClass('show-placeholder')

  displayLoadedContent: =>
    @$el.removeClass('show-placeholder')
